<template>
  <div class="body">
    <el-card class="card" shadow="never">
      <div class="header">
        <h3>修改密码</h3>
      </div>

      <div class="main">
        <!--    步骤条    -->
        <div class="step">
          <div class="step_one">
            <div class="circle active">
              <span> 1</span>
            </div>
            <span>输入原密码</span>
          </div>

          <div class="line"></div>

          <div class="step_two">
            <div class="circle hollow">
              <span> 2</span>
            </div>
            <span>设置密码</span>
          </div>
        </div>

        <div class="password_form">
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="原密码 :" prop="pass">
              <el-input type="password" placeholder="请输入" v-model="ruleForm.pass" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="submitForm('ruleForm')">提 交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "verifyPassword",
  data() {
    return {
      ruleForm: {
        pass: ''
      },
      rules: {
        pass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ]
      }
    };
  },

  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //验证密码逻辑
          console.log('成功')
          // alert('submit!');
          this.$router.push({ name: 'editPassword' })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
}
</script>

<style lang='scss' scoped>
.body {
  margin: 20px 30px 0 30px;
  font-family: PingFangSC-Medium, PingFang SC;

  .header {
    padding: 0 0 20px 30px;
    border-bottom: 1px solid #E8E8E8;

    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
    }
  }

  .main {
    //border: 1px solid red;
    margin: 40px 30px 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    //步骤条
    .step {
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;

      .line {
        width: 192px;
        height: 1px;
        background: #E9E9E9;
        margin: 0 20px;
      }

      .step_one,.step_two {
        display: flex;
        align-items: center;
      }
      .step_one {
        color: #333333;
        font-weight: 500;
      }

      .step_two {
        color: #999999;
        font-weight: 400;
      }

      .circle {
        border-radius: 50%;
        height: 32px;
        width: 32px;
        display: inline-block;
        vertical-align: top;
        margin-right:10px;
        span {
          display: block;

          height: 32px;
          line-height: 32px;
          text-align: center;
          font-size: 16px;
          font-family: HelveticaNeue;
        }

        &.active {
          background: #006FB8;
          color: #FFFFFF;
        }

        &.hollow {
          border: 1px solid rgba(0, 0, 0, 0.15);
          color: rgba(0, 0, 0, 0.25);
        }
      }
    }

    .password_form {
      width: 700px;
      margin-top: 40px;
    }
  }
}
</style>

<style scoped>
>>> .el-card__body {
  padding: 20px 0;
  height: 500px
}
>>> .el-input {
  width: 540px;
}
>>> .el-input__inner {
  height: 32px;
  line-height: 32px;
}
>>> .el-button {
  background-color: #006FB8;
  color: #FFFFFF;
  width: 88px;
  height: 32px;
  padding: 0;
  font-weight: 400;
}
</style>
